var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCanada(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_24_204)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_24_204",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 30,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 30,
    height: 20,
    rx: 2,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_24_204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.0616 3H1V23H9.0616V3Z",
    fill: "#E91E26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2819 3H27.2203V23H35.2819V3Z",
    fill: "#E91E26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2136 3H9.06158V23H27.2136V3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.141 5.59123L16.9491 7.90124C16.8152 8.15568 16.5742 8.1289 16.3331 7.98829L15.4694 7.52628L16.1122 11.075C16.2461 11.7245 15.8109 11.7245 15.6033 11.4433L14.1035 9.68899L13.8624 10.5795C13.8356 10.6933 13.7084 10.8206 13.5276 10.7871L11.6261 10.3719L12.1282 12.2601C12.2354 12.682 12.3157 12.856 12.0211 12.9632L11.3448 13.2913L14.6123 16.0566C14.7396 16.1637 14.8065 16.3512 14.7596 16.5186L14.4717 17.4962C15.5966 17.3622 16.6077 17.2417 17.7325 17.1078C17.833 17.1078 18.0004 17.1948 18.0004 17.3154L17.8531 20.8976H18.4021L18.3151 17.3221C18.3151 17.2015 18.4624 17.1078 18.5628 17.1078C19.6877 17.2417 20.6987 17.3622 21.8236 17.4962L21.5357 16.5186C21.4888 16.3512 21.5558 16.157 21.683 16.0566L24.9505 13.2913L24.2742 12.9632C23.9796 12.8494 24.0599 12.6753 24.1671 12.2601L24.6626 10.3719L22.761 10.7871C22.5735 10.8139 22.453 10.6933 22.4262 10.5795L22.1852 9.68899L20.6853 11.4433C20.4711 11.7245 20.0358 11.7245 20.1765 11.075L20.8192 7.52628L19.9555 7.98829C19.7145 8.1289 19.4734 8.14898 19.3395 7.90124L18.141 5.59123Z",
    fill: "#E91E26"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_24_204",
    x: 0,
    y: 0,
    width: 36,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24_204"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24_204",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanada);
export default __webpack_public_path__ + "static/media/Canada.b22ce485925ec63c14e8672fea1e27b1.svg";
export { ForwardRef as ReactComponent };